import React from 'react';
import '../../components/css/popupstyle.css';
import DashboardHeaderIcons from '../dashboardHeaderIcons';
import $ from 'jquery';
import { userService } from '../../_services/user.service';
import loader from '../../components/css/dark/img/loader.gif';

class CommissionAllBinPopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            error: '',
            isOverride: false,
            isBonusAllowed: false
        }

        if (localStorage.getItem('user') == null || localStorage.getItem('user') == "" || localStorage.getItem('user') == "{}") {
            userService.logout();
        }
        try {
            this.state = {
                userdata: JSON.parse(localStorage.getItem('user')),
                paramsName: JSON.parse(localStorage.getItem('user')).paramsname,
                CommissionList: [],// this.props.CommissionList,
                MonthList: [],
                paidClaims: '',
                commissionPerClaim: '',
                isRuleBased: '',
                totalBonusClaims: ''
            };
        }
        catch (error) { }
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    componentDidMount() {
        this.GetCommission_Separate(this.state.userdata.wholesaler, this.state.userdata.wholesaler_Id, '');
    }
    handleOnChange = (event) => {
        this.GetCommission_Separate(this.state.userdata.wholesaler, this.state.userdata.wholesaler_Id, event.target.value);
    };

    GetCommission_Separate(whname, wholesaler_Id, mname) {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        this.setState({ loader: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ whname, wholesaler_Id, mname })
        };
        return fetch(`/api/ws/wh_commission_type_allbin`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                setTimeout(() => {
                    $('.popup').addClass('mfp-ready');
                    $('.popup').addClass('mfp-bg');
                    $('.popup').addClass('mfp-with-anim');
                }, 5);
                try {
                    if (apidata.length > 0) {
                        let commissionPerClaim;
                        if (apidata[0].commList_Commission[0].isRuleBased === "1.00") {
                            commissionPerClaim = JSON.parse(apidata[0].commList_Commission[0].commission);
                        } else {
                            commissionPerClaim = apidata[0].commList_Commission[0].commission
                        }
                        let startIndex;
                        apidata[0]["monthList"].filter((item, index) => {
                            if (item.monthYearname === "December,2023") {
                                startIndex = index;
                            }
                        });
                        let filterMonthList = apidata[0]["monthList"].filter((item, index) => {
                            return index < startIndex
                        });
                        this.setState({
                            CommissionList: apidata[0]["commList"], isRuleBased: apidata[0].commList_Commission[0].isRuleBased, commissionPerClaim: commissionPerClaim, paidClaims: apidata[0].commList_Commission[0].paidClaims, MonthList: filterMonthList, loader: false, error: '', isOverride: apidata[0]["isOverride"], totalBonusClaims: apidata[0].commList_Commission[0].totalBonusClaims, isBonusAllowed: apidata[0]["isBonusAllowed"]
                        });
                        if (this.state.isOverride) {
                            $('.popup_inner').addClass('gainHeight');
                        } else {
                            $('.popup_inner').removeClass('gainHeight');
                        }
                    } else {
                        $('.popup_inner').addClass('no-data');
                        this.setState({ loader: false, error: 'Data not found' });
                    }
                }
                catch (error) {
                }
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }

    render() {
        const { loader, error } = this.state;
        return (
            <div className={this.state.isOverride ? 'popup mfp-zoom-in WhCommissionPopup more-height' : 'popup mfp-zoom-in WhCommissionPopup' }>
                <div className={this.state.isBonusAllowed ? 'popup_inner bonus_allowed' : 'popup_inner'}>

                    <h1>{this.props.text}<button onClick={this.props.closeCommissionAllBinPopup}>X</button></h1>
                    <div className="WhCommission">
                        {
                            loader ? <div className="theme-loader"></div> : null
                        }
                    </div>
                    {
                        this.state.CommissionList.length > 0 ?
                            <div className="WhCommission">
                                <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
                                    <div className="selectSection">
                                        <label>Select Month, Year</label>
                                        <span className="down-arrow"></span>
                                        <select className="form-Control" id="commissionSelect" onChange={this.handleOnChange} value={this.state.value} >
                                            {
                                                this.state.MonthList != null ?
                                                    this.state.MonthList.map((obj, index) => {
                                                        return <option value={obj.monthYearname}>{obj.monthYearname.replace(',', ', ')}</option>
                                                    }) : null
                                            }
                                        </select>
                                    </div>
                                    <div className={this.state.isBonusAllowed ? "adjust-claim" : ''}>
                                    <div className="payable-commission">
                                        <span className="left">Total Paid Claims</span>
                                        <span className="right">{this.state.paidClaims}</span>
                                    </div>
                                    <div className="payable-commission perclaim">
                                        <span className="left">Commission per Claim ($)</span>
                                        <span className="right manage-height">
                                            {
                                                this.state.isRuleBased === "1.00" ?
                                                    <label>
                                                        {
                                                            this.state.commissionPerClaim.map((item, index) => {
                                                                return <span>{item.from + ' - ' + item.to + ': ' + '$' + item.commission}</span>
                                                            })
                                                        }
                                                    </label> :
                                                    <label>
                                                        <span>{'$' + this.state.commissionPerClaim}</span>
                                                    </label>
                                            }
                                        </span>
                                    </div>
                                    {
                                        this.state.isBonusAllowed ? <div>
                                            <div className="payable-commission">
                                                <span className="left">Total Bonus Claims</span>
                                                <span className="right">{this.state.totalBonusClaims}</span>
                                            </div>
                                            <div className="payable-commission">
                                                <span className="left">{this.state.CommissionList[10]["wholesalerCommissionType"]}</span>
                                                <span className="right">${this.state.CommissionList[10]["wholesalerCommissionTotal"]}</span>
                                            </div>
                                        </div> : null
                                    }
                                    <div className="payable-commission">
                                        <span className="left">{this.state.CommissionList[0]["wholesalerCommissionType"]}</span>
                                        <span className="right">${this.state.CommissionList[0]["wholesalerCommissionTotal"]}</span>
                                    </div>
                                    {
                                        this.state.isOverride ? <div>
                                            <div className="payable first-one">
                                                <span className="left">{this.state.CommissionList[1]["wholesalerCommissionType"]}</span>
                                                <span className="right">${this.state.CommissionList[1]["wholesalerCommissionTotal"]}</span>
                                            </div>
                                            <div className="payable">
                                                <span className="left">{this.state.CommissionList[2]["wholesalerCommissionType"]}</span>
                                                <span className="right">${this.state.CommissionList[2]["wholesalerCommissionTotal"]}</span>
                                            </div>

                                        </div> : null
                                    }
                                    {
                                        this.state.isBonusAllowed ? <div>
                                            <div className={this.state.isOverride ? "payable" : "payable first-one" }>
                                                <span className="left">{this.state.CommissionList[11]["wholesalerCommissionType"]}</span>
                                                <span className="right">${this.state.CommissionList[11]["wholesalerCommissionTotal"]}</span>
                                            </div>
                                            <div className={this.state.isOverride ? 'payable' : 'payable'}>
                                                <span className="left">{this.state.CommissionList[3]["wholesalerCommissionType"]}</span>
                                                <span className="right">${this.state.CommissionList[3]["wholesalerCommissionTotal"]}</span>
                                            </div>
                                        </div> :
                                        <div className={this.state.isOverride ? 'payable' : 'payable first-one'}>
                                            <span className="left">{this.state.CommissionList[3]["wholesalerCommissionType"]}</span>
                                            <span className="right">${this.state.CommissionList[3]["wholesalerCommissionTotal"]}</span>
                                        </div>
                                    }
                                    <div className="payable">
                                        <span className="left">{this.state.CommissionList[4]["wholesalerCommissionType"]}</span>
                                        <span className="right">${this.state.CommissionList[4]["wholesalerCommissionTotal"]}</span>
                                    </div>
                                    <div className="payable">
                                        <span className="left">{this.state.CommissionList[5]["wholesalerCommissionType"]}</span>
                                        <span className="right">${this.state.CommissionList[5]["wholesalerCommissionTotal"]}</span>
                                        </div>
                                    </div>
                                    <button class="commission-btn btn-theme-color" onClick={this.props.closeCommissionAllBinPopup}>Close</button>
                                </form>
                            </div> : <div>
                                {
                                    loader ? <div className="selectSection please-wait"><h3>Please wait...</h3></div> : null
                                }
                                {
                                    loader ? null :
                                    <div className="WhCommission">
                                        <form>
                                            <div className={this.state.isBonusAllowed ? "adjust-claim" : ''}>
                                                <div className="payable-commission">
                                                    <span className="left">Total Paid Claims</span>
                                                    <span className="right">0</span>
                                                </div>
                                                <div className="payable-commission">
                                                    <span className="left">Total Revenue</span>
                                                    <span className="right">$0.00</span>
                                                </div>
                                                <div className="payable first-one">
                                                    <span className="left">Total Payable</span>
                                                    <span className="right">$0.00</span>
                                                </div>
                                                <div className="payable">
                                                    <span className="left">Payable To Distributor</span>
                                                    <span className="right">$0.00</span>
                                                </div>
                                                <div className="payable">
                                                    <span className="left">Payable To Sub Distributor</span>
                                                    <span className="right">$0.00</span>
                                                </div>
                                            </div>
                                            <button class="commission-btn btn-theme-color" onClick={this.props.closeCommissionAllBinPopup}>Close</button>
                                        </form>
                                    </div>
                                }
                            </div>
                    }
                </div>
            </div>
        );
    }
}
export default CommissionAllBinPopup;